import { useEffect, useState } from 'react';
import { useAuth } from 'src/components/AuthProvider/AuthProvider';
import { useAnalytics } from 'src/components/AnalyticsProvider/AnalyticsProvider';

export const useInitializeTealium = (): void => {
  const { user, corpData } = useAuth();
  const { sendTealiumPageView } = useAnalytics();
  const [isTealiumInitialized, setIsTealiumInitialized] = useState(false);

  useEffect(() => {
    if (user && corpData && !isTealiumInitialized) {
      sendTealiumPageView({
        pageGroup: 'User Initialization',
        pageName: 'All',
        subGroup: 'This sets up Tealium with user and corp data',
      });

      setIsTealiumInitialized(true);
    }
  }, [user, corpData, isTealiumInitialized]);
};
